var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tipoFornecedor === 'APROVADOR_AUTORIZADO')?_c('usuario-fornecedor-aprovador-autorizado-form',{attrs:{"somente-leitura":_vm.somenteLeitura}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }